/** Couleurs alignées sur l'app mobile Liberty (splash, écrans, boutons). */
export const libertyBrand = {
  bg: '#0f0c29',
  surface: '#1a0d2e',
  surfaceAlt: '#261838',
  accent: '#ff6b35',
  accentLight: '#ff8c5a',
  splash: '#0D0540',
};

export const libertyLogoSrc = `${process.env.PUBLIC_URL || ''}/liberty-logo.png`;
